
import { /* grey, */ blueGrey, /* deepPurple */ } from '@mui/material/colors';
import { defaultTheme } from 'react-admin';

const theme = {
    ...defaultTheme,
    palette: {
        primary: {
            main: 'rgb(31, 119, 180)'
        },
        secondary: {
            light: '#013c01',
            main: '#123452',
            dark: '#000e00',
            contrastText: '#fff',
        },
        default: {
            main: 'rgb(62, 91, 105)'
        }
        // background: {paper: '#18202c'}
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
        fontSize: 14,
        h1: {
            fontWeight: 600,
            fontSize: '2rem',
        },
        h2: {
            fontWeight: 500,
            fontSize: '1.75rem',
        },
        button: {
            textTransform: 'none', // Avoid uppercase text to maintain professionalism
            fontWeight: 500,
        },
    },
    components: {
        ...defaultTheme.components,
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6, // Slightly rounded corners for a more professional look
                    padding: '8px 16px',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Soft shadow for subtle depth
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: blueGrey[800],
                },
            },
        },
    },
    shape: {
        borderRadius: 4, // Default for consistent professionalism
    },
    overrides: {
        MuiFilledInput: {
            root: {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
                '&$disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            },
        },
        MuiTabs: {
            root: {
                ['@media print']: { // eslint-disable-line no-useless-computed-key
                    display: 'none'
                }
            }
        },
        MuiToolbar: {
            root: {
                ['@media print']: { // eslint-disable-line no-useless-computed-key
                    display: 'none !important'
                }
            }
        },
        MuiDrawer: {
            paper: {
                background: '#18202c',
                // background: 'white'
            },
        },
        MuiChip: { // override the styles of all instances of this component
            root: { // Name of the rule
                color: 'white', // Some CSS
                backgroundColor: 'rgba(31, 119, 180, 0.59)',
            },
        },
        MuiSelect: {
            root: {
                height: 'auto'
            }
        },
        RaMenuItemLink: {
            root: {
                borderLeft: '3px solid #fff'
                // paddingLeft: '35px'
            },
            active: {
                borderLeft: '4px solid rgb(76, 175, 80)',
                'backgroundColor': '#efefef'
                //     paddingLeft: '35px'
            },
        },
        // MuiMenuItem: {
        //     root: {
        //         // backgroundColor: '#d31145',
        //         '&$selected': {
        //             backgroundColor: 'linear-gradient(45deg, red 30%, orange 90%)',
        //             // color: 'white'
        //         },
        //     }
        // }   
    },
};

export default theme